import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { AppBar, AppBarProps, Typography, Toolbar,  Theme } from '@mui/material';

interface NavBarProps extends AppBarProps {
    children?: React.ReactNode;
    menuClicked?: (event?: any) => void;
}

const useStyles = makeStyles()((theme: Theme) =>
    ({
        menuButton: {
            marginRight: theme.spacing(2),
        },

        title: {
            flexGrow: 2,
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block',
            },
            paddingLeft: 240,
        },

        topRight: {
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            marginLeft: 0,
            display: 'flex',
            flexDirection: 'row',
            flexGrow: 2,
            justifyContent: 'flex-end',
            alignItems: 'center',
            height: 64,
        }
    }));

const NavBar: React.FC<NavBarProps> = (props) => {
    const { children, ...rest } = props;
    const { classes } = useStyles();

    return (
        <AppBar position="static" {...rest} elevation={0}>
            <Toolbar>
                <Typography className={classes.title} variant="h6" noWrap>
                    {props.title}
                </Typography>
                {children && <div className={classes.topRight}>{children}</div>}
            </Toolbar>
        </AppBar>
    );
};

export default NavBar;
